import * as S from './styles'
import { Tooltip, SlimButton } from 'components'
import { Dispatch, SetStateAction, useEffect } from 'react'
import { useSelector } from 'store/store'
import { getOvStatusOptionsToSap, OvDataToSap } from 'container/ManageOVDetails/utils'
import { SapOptionsToOvStatus } from 'store/OVContext/ovContextTypes'
import { SapModalTypes } from 'container/ManageOVDetails/components/SapModal'

type CheckedOVsVerificationProps = {
  setSapModal: Dispatch<SetStateAction<SapModalTypes | undefined>>
  ovsSapData: SapOptionsToOvStatus
  setOvsSapData: Dispatch<SetStateAction<SapOptionsToOvStatus>>
}

const CheckedOVsVerification = ({
  setSapModal,
  ovsSapData,
  setOvsSapData
}: CheckedOVsVerificationProps) => {
  const { checkedOvs } = useSelector((state) => state.salesOrder)

  useEffect(() => {
    if (checkedOvs.length) {
      const ovDataToSap: OvDataToSap[] = checkedOvs.map((ov) => ({
        number: ov.NumeroOrdemVenda,
        changeDate: ov.DataAlteracao ?? '',
        statusKey: ov.StatusOrdemVenda
      }))
      setOvsSapData(getOvStatusOptionsToSap(ovDataToSap))
    }
  }, [checkedOvs])

  const renderReturnToSalesAreaButton = () => (
    <S.ButtonSap>
      <SlimButton
        content="Devolver"
        variant="secondary"
        disabled={!ovsSapData.isValidToReturnToSalesArea}
        onClick={() => setSapModal('salesAreaModal')}
      />
    </S.ButtonSap>
  )

  const renderReturnSapButton = () => (
    <S.ButtonSap>
      <SlimButton
        content="Retornar do SAP"
        variant="secondary"
        disabled={!ovsSapData.isValidToReturnFromSap}
        onClick={() => setSapModal('returnModal')}
      />
    </S.ButtonSap>
  )

  const renderSendSapButton = () => (
    <S.ButtonSap>
      <SlimButton
        content="Enviar ao SAP"
        variant="primary"
        disabled={!ovsSapData.isValidToSendToSap}
        onClick={() => setSapModal('sendModal')}
      />
    </S.ButtonSap>
  )

  return (
    <S.Wrapper>
      <S.MessageCheckedOVs>
        O que deseja fazer com os itens selecionados?
      </S.MessageCheckedOVs>
      <S.ButtonsSapWrapper>
        {ovsSapData.isValidToReturnToSalesArea ? (
          renderReturnToSalesAreaButton()
        ) : (
          <Tooltip title="Apenas os status 09, 10 e 15 permitem a ação de Devolver para área de vendas">
            {renderReturnToSalesAreaButton()}
          </Tooltip>
        )}

        {ovsSapData.isValidToReturnFromSap ? (
          renderReturnSapButton()
        ) : (
          <Tooltip title="Apenas os status 20, 21, 22 e 40 permitem a ação de Retornar do SAP">
            {renderReturnSapButton()}
          </Tooltip>
        )}

        {ovsSapData.isValidToSendToSap ? (
          renderSendSapButton()
        ) : (
          <Tooltip title="Apenas os status 00, 05 e 08 permitem a ação de Enviar ao SAP">
            {renderSendSapButton()}
          </Tooltip>
        )}
      </S.ButtonsSapWrapper>
    </S.Wrapper>
  )
}

export default CheckedOVsVerification
